import { Outlet } from "react-router-dom";

export default function SettingsLayout() {
  return (
    <div className="p-6 lg:p-8">
      <Outlet />
    </div>
  );
}
